import {
	fetchSbkEligibilityFailed,
	fetchSbkEligibilitySuccess,
} from "modules/actions/sbkEligibility";
import {IS_SBK_ENABLED} from "modules/constants";
import {Api} from "modules/utils";
import {call, put} from "typed-redux-saga";

export const fetchSbkEligibilitySaga = function* () {
	if (!IS_SBK_ENABLED) {
		return;
	}

	try {
		const result = yield* call(Api.Betting.sbkEligibility);

		if (result.success?.eligibility) {
			yield* put(fetchSbkEligibilitySuccess(result.success.eligibility));
		} else {
			yield* put(fetchSbkEligibilityFailed());
		}
	} catch (err) {
		yield* put(fetchSbkEligibilityFailed());
	}
};
